// src/components/LoginSignupLayout.tsx
import React from 'react';

interface LoginSignupLayoutProps {
  children: React.ReactNode;
  currentUserType: 'buyer' | 'seller';
  onUserTypeChange: (type: 'buyer' | 'seller') => void;
}

const LoginSignupLayout: React.FC<LoginSignupLayoutProps> = ({ children, currentUserType, onUserTypeChange }) => {
  
  // Tailwind classes for the active and inactive button states
  const baseClasses = "flex-1 py-3 text-sm font-bold rounded-t-lg transition-colors duration-200 text-center cursor-pointer";
  const activeClasses = "bg-white text-purple-600 border-b-4 border-purple-600 shadow-md";
  const inactiveClasses = "bg-gray-100 text-gray-500 hover:bg-gray-200";

  // Check if the current role is Seller
  const isSeller = currentUserType === 'seller';
  
  // Placeholder Image URL: Aap yahan apni image ka URL daal sakte hain.
  const imageUrl = "https://img.freepik.com/premium-vector/tablet-login-concept-illustration_114360-7963.jpg"; 

  return (
    <div className="flex w-full h-[600px] bg-white rounded-lg shadow-lg overflow-hidden">
      
      {/* -------------------- IMAGE Panel (Dynamic Left/Right) -------------------- */}
      {/* Order change se smooth swap hoga */}
     <div 
  // Default: buyer -> order-1 (Left). Seller: order-2 (Right)
  className={`hidden md:flex flex-col items-center justify-center p-8 w-1/2 text-white text-center bg-center  bg-no-repeat transition-all duration-700 ease-in-out ${isSeller ? 'md:order-2' : 'md:order-1'}`}
  style={{ 
    backgroundImage: `url('${imageUrl}')`,
    position: 'relative',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',

  }}
>

        {/* Semi-transparent Overlay (Image ko thoda dark karne ke liye) */}
        {/* <div className="absolute inset-0 bg-black opacity-40"></div>  */}
        
        {/* Content over image */}
        {/* <div className="relative z-10"> 
            <h2 className="text-3xl font-bold mb-2">B2Bhaarat</h2>
            <p className="text-sm">
                Join the largest B2B marketplace. Connect with verified buyers and
                sellers to grow your business.
            </p>
        </div> */}
      </div>

      {/* -------------------- Form Panel (Dynamic Left/Right) -------------------- */}
      {/* Order change se smooth swap hoga */}
      <div 
        // Default: buyer -> order-2 (Right). Seller: order-1 (Left)
        className={`w-full md:w-1/2 p-8 flex flex-col justify-center transition-all duration-1000 ease-in-out ${isSeller ? 'md:order-1' : 'md:order-2'}`}
      >
        
        {/* BUTTONS: Role Selection Toggle */}
        <div className="flex mb-6 -mt-4 justify-center border-b border-gray-200">
          <button
            onClick={() => onUserTypeChange('buyer')}
            className={`${baseClasses} ${currentUserType === 'buyer' ? activeClasses : inactiveClasses}`}
          >
           as a Buyer
          </button>
          <button
            onClick={() => onUserTypeChange('seller')}
            className={`${baseClasses} ${currentUserType === 'seller' ? activeClasses : inactiveClasses}`}
          >
           as a Seller
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};

export default LoginSignupLayout;